import { render, staticRenderFns } from "./MailSendField.vue?vue&type=template&id=3bf197e6&scoped=true"
import script from "./MailSendField.ts?vue&type=script&lang=ts&external"
export * from "./MailSendField.ts?vue&type=script&lang=ts&external"
import style0 from "./MailSendField.vue?vue&type=style&index=0&id=3bf197e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf197e6",
  null
  
)

export default component.exports